var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.45 8.659c-.77.19-1.4.82-1.59 1.59a2.206 2.206 0 0 0 2.68 2.68c.78-.19 1.41-.82 1.59-1.59a2.206 2.206 0 0 0-2.68-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51 17.77a9.545 9.545 0 0 1-3.05-6.98c0-5.26 4.28-9.54 9.54-9.54 5.26 0 9.54 4.28 9.54 9.54 0 2.66-1.07 5.12-3.01 6.95-.3.28-.78.27-1.06-.03-.28-.3-.27-.78.03-1.06a7.938 7.938 0 0 0 2.54-5.85c0-4.43-3.61-8.04-8.04-8.04S3.96 6.37 3.96 10.8c0 2.26.91 4.34 2.57 5.88.3.28.32.76.04 1.06a.763.763 0 0 1-1.06.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.49 15.099a.746.746 0 0 1-.03-1.06c.83-.88 1.29-2.04 1.29-3.24 0-2.62-2.13-4.74-4.74-4.74a4.75 4.75 0 0 0-4.74 4.74c0 1.21.46 2.36 1.29 3.24.28.3.27.78-.03 1.06-.3.29-.78.27-1.06-.03a6.229 6.229 0 0 1-1.7-4.27c0-3.44 2.8-6.24 6.24-6.24 3.44 0 6.24 2.8 6.24 6.24 0 1.59-.6 3.11-1.7 4.27a.763.763 0 0 1-1.06.03zM8.86 18.45C7.72 19.88 8.74 22 10.56 22h2.87c1.83 0 2.85-2.12 1.7-3.54l-1.44-1.79a2.16 2.16 0 0 0-3.39-.01l-1.44 1.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAirdrop);
export default __webpack_public_path__ + "static/media/vuesax-bold-airdrop.fbb3a9663dc1ef10e829b82a7cd071bc.svg";
export { ForwardRef as ReactComponent };